import { Trans, useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"
import type { HeroCityPoiProps } from "@/components/LuggageStorage/HeroCityPoi/HeroCityPoi"
import type { AggregateRating, CityData } from "@/libs/bounce/types"
import { interpolateText } from "@/libs/prismic/helpers"

export type UseHeroOptions = {
  city: CityData
  aggregateRating: AggregateRating
  interpolations: Interpolations
}

export const useHero = ({ city, interpolations, aggregateRating }: UseHeroOptions): HeroCityPoiProps => {
  const { t } = useTranslation("marketing-ls-city")

  const title = city.splitTestData.h1 ? (
    interpolateText(city.splitTestData.h1, interpolations)
  ) : (
    <Trans
      ns="marketing-ls-city"
      i18nKey="screen.cityScreen.hero.title"
      defaults="<span>{{CITY_NAME}}</span> luggage storage"
      values={interpolations}
      components={{ span: <span className="block lg:inline-block" /> }}
    />
  )

  const subtitle = t("screen.cityScreen.hero.subtitle", "from {PRICE} / day", interpolations)

  const cta = t("cmp.heroCityPoi.ctaV1", "Search {PLACE_NAME}", {
    PLACE_NAME: city.translatedName,
  })

  return {
    aggregateRating,
    cta,
    from: "City",
    image: city.image,
    numLocations: `${city.storeCount}`,
    placeName: city.name,
    query: city.query,
    subtitle,
    title,
  }
}
